import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import FieldList from './components/field-list';
type UserDataProps = {
  detail: AuditEventDetail;
};
const UserData = t0 => {
  const $ = _c(25);
  const {
    detail
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.userData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  let actionText;
  let fields;
  if (detail.kind === "decrypt_user_data") {
    fields = detail.data.decryptedFields;
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    actionText = t2;
  } else {
    if (detail.kind === "delete_user_data") {
      fields = detail.data.deletedFields;
      let t2;
      if ($[3] !== t) {
        t2 = t(_temp2);
        $[3] = t;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      actionText = t2;
    } else {
      if (detail.kind === "update_user_data") {
        fields = detail.data.updatedFields;
        let t2;
        if ($[5] !== t) {
          t2 = t(_temp3);
          $[5] = t;
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        actionText = t2;
      } else {
        return null;
      }
    }
  }
  const fpId = detail.data.fpId;
  let t2;
  if ($[7] !== actionText) {
    t2 = <span className="text-body-2 text-tertiary">{actionText}</span>;
    $[7] = actionText;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== fields) {
    t3 = <FieldList fields={fields} />;
    $[9] = fields;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = t(_temp4);
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <span className="text-body-2">{t4}</span>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = `/users/${fpId}`;
  let t7;
  if ($[15] !== t) {
    t7 = t(_temp5);
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <LinkButton href={t6} iconComponent={IcoArrowTopRight16} target="_blank">{t7}</LinkButton>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t2 || $[21] !== t3 || $[22] !== t5 || $[23] !== t8) {
    t9 = <>{t2}{t3}{t5}{t8}</>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default UserData;
function _temp($) {
  return $.decrypted;
}
function _temp2($_0) {
  return $_0.deleted;
}
function _temp3($_1) {
  return $_1.updated;
}
function _temp4($_2) {
  return $_2.ofA;
}
function _temp5($_3) {
  return $_3.user;
}